var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',{attrs:{"text":_vm.selectedChannelName}},_vm._l((_vm.channels),function(channel){return _c('b-dropdown-item',{key:channel.id,on:{"click":function($event){return _vm.channelSelected(channel)}}},[_vm._v(_vm._s(channel.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }